import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RouterModule } from '@angular/router';
import { AskConfirmationDialogComponent } from './components/ask-confirmation-dialog/ask-confirmation-dialog.component';
import { TextSearchFilterComponent } from './components/coll-filters/search-filter/text-search-filter.component';
import { ConfirmActionComponent } from './components/confirm-action/confirm-action.component';
import { DeleteButtonWithConfirmationComponent } from './components/delete-button-with-confirmation/delete-button-with-confirmation.component';
import { FileUploadButtonComponent } from './components/file-upload-button/file-upload-button.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { FilterByLetterComponent } from './components/filter-by-letter/filter-by-letter.component';
import { ImageUploaderComponent } from './components/image-uploader/image-uploader.component';
import { NavigateBackComponent } from './components/navigate-back/navigate-back.component';
import { OperationConfirmDialogComponent } from './components/operation-confirm-dialog/operation-confirm-dialog.component';
import { PageFiltersAndCtaComponent } from './components/page-filters-and-cta/page-filters-and-cta.component';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PageSpinnerComponent } from './components/page-spinner/page-spinner.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { EditUserDetailsDialogComponent } from './components/users-management/edit-user-details-dialog/edit-user-details-dialog.component';
import { InviteUserDialogComponent } from './components/users-management/users/user-invite-dialog.component';
import { UserPropsFilterDialogComponent } from './components/users-management/users/user-props-filter-dialog.component';
import { UsersManagementComponent } from './components/users-management/users/users.component';

import { i18n, UppercaseFirstCharPipe } from './pipes';
import { RemapRolePipe } from './pipes/remap-role.pipe';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
@NgModule({
  exports: [
    UppercaseFirstCharPipe,
    PageHeaderComponent,
    ConfirmActionComponent,
    FilterByLetterComponent,
    UserDetailsComponent,
    TextSearchFilterComponent,
    PageSpinnerComponent,
    ImageUploaderComponent,
    DeleteButtonWithConfirmationComponent,
    UsersManagementComponent,
    PageFiltersAndCtaComponent,
    i18n,
    FileUploaderComponent,
    OperationConfirmDialogComponent,
    SafeHTMLPipe,
    TruncatePipe,
    FileUploadButtonComponent,
    NavigateBackComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ClipboardModule,
    NavigateBackComponent,
    PageHeaderComponent,
    ConfirmActionComponent,
    FilterByLetterComponent,
    UserDetailsComponent,
    TextSearchFilterComponent,
    AskConfirmationDialogComponent,
    PageSpinnerComponent,
    UppercaseFirstCharPipe,
    ImageUploaderComponent,
    DeleteButtonWithConfirmationComponent,
    UsersManagementComponent,
    EditUserDetailsDialogComponent,
    InviteUserDialogComponent,
    UserPropsFilterDialogComponent,
    PageFiltersAndCtaComponent,
    FileUploaderComponent,
    OperationConfirmDialogComponent,
    i18n,
    RemapRolePipe,
    SafeHTMLPipe,
    TruncatePipe,
    FileUploadButtonComponent,
  ],
  providers: [
    {
      provide: i18n,
      useClass: i18n,
    },
  ],
})
export class SharedModule {}
